import { render, staticRenderFns } from "./admin-areas.vue?vue&type=template&id=10a7b2be&scoped=true"
import script from "./admin-areas.vue?vue&type=script&lang=js"
export * from "./admin-areas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a7b2be",
  null
  
)

export default component.exports